import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Packages from './pages/Packages';
import PackageDetail from './pages/PackageDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import BookingSuccess from './pages/BookingSuccess';
import BookingCancelled from './pages/BookingCancelled';
import CancellationPolicy from './pages/CancellationPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import AnalyticsTracker from './components/AnalyticsTracker';
import { Toaster } from 'sonner';
import { CurrencyProvider } from './context/CurrencyContext';

// Admin imports
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminPackages from './pages/admin/AdminPackages';
import AdminBookings from './pages/admin/AdminBookings';
import AdminContacts from './pages/admin/AdminContacts';
import AdminTestimonials from './pages/admin/AdminTestimonials';
import AdminGallery from './pages/admin/AdminGallery';
import AdminSiteContent from './pages/admin/AdminSiteContent';

import SafariLibrary from './pages/SafariLibrary';

import './App.css';

function App() {
  return (
    <div className="App">
      <CurrencyProvider>
        <BrowserRouter>
          <AnalyticsTracker />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<><Navbar /><Home /><Footer /><WhatsAppButton /></>} />
            <Route path="/packages" element={<><Navbar /><Packages /><Footer /><WhatsAppButton /></>} />
            <Route path="/packages/:id" element={<><Navbar /><PackageDetail /><Footer /><WhatsAppButton /></>} />
            <Route path="/about" element={<><Navbar /><About /><Footer /><WhatsAppButton /></>} />
            <Route path="/contact" element={<><Navbar /><Contact /><Footer /><WhatsAppButton /></>} />
            <Route path="/safari-library" element={<><Navbar /><SafariLibrary /><Footer /><WhatsAppButton /></>} />
            <Route path="/cancellation-policy" element={<><Navbar /><CancellationPolicy /><Footer /><WhatsAppButton /></>} />
            <Route path="/terms-and-conditions" element={<><Navbar /><TermsAndConditions /><Footer /><WhatsAppButton /></>} />
            
            {/* Booking Status Routes */}
            <Route path="/booking-success" element={<BookingSuccess />} />
            <Route path="/booking-cancelled" element={<BookingCancelled />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="packages" element={<AdminPackages />} />
              <Route path="bookings" element={<AdminBookings />} />
              <Route path="contacts" element={<AdminContacts />} />
              <Route path="testimonials" element={<AdminTestimonials />} />
              <Route path="gallery" element={<AdminGallery />} />
              <Route path="site-content" element={<AdminSiteContent />} />
            </Route>
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </CurrencyProvider>
    </div>
  );
}

export default App;